import { ActionDispatchers } from '../action';
import {
    HEADER_CAPTCHA_ANSWER,
    HEADER_CAPTCHA_HASH,
    INPUT_CAPTCHA_RESULT,
    INPUT_CITY,
    INPUT_CONTRACT_NUMBER,
    INPUT_CUSTOMER_NUMBER,
    INPUT_EMAIL,
    INPUT_FIRST_NAME,
    INPUT_HOUSE_NUMBER,
    INPUT_LAST_NAME,
    INPUT_NOTE,
    INPUT_POSTAL_CODE,
    INPUT_STREET,
    INPUT_TERMINATION_DATE,
} from '../constant';
import {
    ICaptcha,
    ICustomerInformation,
} from '../interface';

/**
 * on Submit it collects all the input values and triggers the action
 */
export const terminateContractForm = (terminateContractAction: ActionDispatchers['terminateContract'], captchaHash: string) => {
    const customerInformation: ICustomerInformation = {
        firstName: '',
        lastName: '',
        street: '',
        buildingNumber: '',
        postcode: '',
        city: '',
        emailAddress: '',
        customerNumber: '',
        contractNumber: '',
        desiredTerminationDate: '',
        note: '',
        timestamp: undefined,
    };
    const captcha: ICaptcha = {
        [HEADER_CAPTCHA_HASH]: '',
        [HEADER_CAPTCHA_ANSWER]: '',
    };

    // personal data
    customerInformation.firstName = (<HTMLInputElement>document.getElementById(INPUT_FIRST_NAME)).value;
    customerInformation.lastName = (<HTMLInputElement>document.getElementById(INPUT_LAST_NAME)).value;
    customerInformation.street = (<HTMLInputElement>document.getElementById(INPUT_STREET)).value;
    customerInformation.buildingNumber = (<HTMLInputElement>document.getElementById(INPUT_HOUSE_NUMBER)).value;
    customerInformation.postcode = (<HTMLInputElement>document.getElementById(INPUT_POSTAL_CODE)).value;
    customerInformation.city = (<HTMLInputElement>document.getElementById(INPUT_CITY)).value;
    customerInformation.emailAddress = (<HTMLInputElement>document.getElementById(INPUT_EMAIL)).value;

    // contract data
    customerInformation.customerNumber = (<HTMLInputElement>document.getElementById(INPUT_CUSTOMER_NUMBER)).value;
    customerInformation.contractNumber = (<HTMLInputElement>document.getElementById(INPUT_CONTRACT_NUMBER)).value;
    customerInformation.desiredTerminationDate = (<HTMLInputElement>document.getElementById(INPUT_TERMINATION_DATE)).value;
    customerInformation.note = (<HTMLInputElement>document.getElementById(INPUT_NOTE)).value;

    // captcha
    captcha[HEADER_CAPTCHA_HASH] = captchaHash;
    captcha[HEADER_CAPTCHA_ANSWER] = (<HTMLInputElement>document.getElementById(INPUT_CAPTCHA_RESULT)).value;
    terminateContractAction(customerInformation, captcha);
};
